import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'lt',
  months: [
    'sausio',
    'vasario',
    'kovo',
    'balandžio',
    'gegužės',
    'birželio',
    'liepos',
    'rugpjūčio',
    'rugsėjo',
    'spalio',
    'lapkričio',
    'gruodžio',
  ],
  monthsShort: [
    'sausio',
    'vasario',
    'kovo',
    'balandžio',
    'gegužės',
    'birželio',
    'liepos',
    'rugpjūčio',
    'rugsėjo',
    'spalio',
    'lapkričio',
    'gruodžio',
  ],
  weekdays: [
    'Sekmadienis',
    'Pirmadienis',
    'Antradienis',
    'Trečiadienis',
    'Ketvirtadienis',
    'Penktadienis',
    'Šeštadienis',
  ],
  weekdaysMin: ['S', 'Pr', 'A', 'T', 'K', 'P', 'Š'],
  weekdaysShort: ['S', 'Pr', 'A', 'T', 'K', 'P', 'Š'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'YYYY-MM-DD',
    LL: 'YYYY MMMM D',
    'LL-D': 'YYYY MMMM mėn.',
    'LL-Y': 'MMMM D',
    LLL: 'YYYY MMMM D, HH:mm',
    'LLL-Y': 'MMMM D, HH:mm',
    LLLL: 'dddd, YYYY MMMM D, HH:mm',
    'LLLL-Y': 'dddd, MMMM D HH:mm',
    l: 'YYYY MM DD',
    'l-Y': 'MM DD',
    ll: 'YYYY MMMM D',
    'll-Y': 'MMMM D',
    lll: 'YYYY MMMM D, HH:mm',
    'lll-Y': 'MMMM D, HH:mm',
    llll: 'ddd, YYYY MMMM D, HH:mm',
    'llll-Y': 'ddd, MMMM D, HH:mm',
    'll-Y+w': 'MM-DD, ddd',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'YYYY [m]. MMMM D [d]. HH:mm ([GMT]Z)',
  },
  past: {
    y: { one: 'prieš %s m.', few: 'prieš %s m.', many: 'prieš %s m.', other: 'prieš %s m.' },
    M: { one: 'prieš %s mėn.', few: 'prieš %s mėn.', many: 'prieš %s mėn.', other: 'prieš %s mėn.' },
    w: { one: 'prieš %s sav.', few: 'prieš %s sav.', many: 'prieš %s sav.', other: 'prieš %s sav.' },
    d: { one: 'prieš %s d.', few: 'prieš %s d.', many: 'prieš %s d.', other: 'prieš %s d.' },
    h: { one: 'prieš %s val.', few: 'prieš %s val.', many: 'prieš %s val.', other: 'prieš %s val.' },
    m: { one: 'prieš %s min.', few: 'prieš %s min.', many: 'prieš %s min.', other: 'prieš %s min.' },
    s: { one: 'prieš %s sek.', few: 'prieš %s sek.', many: 'prieš %s sek.', other: 'prieš %s sek.' },
  },
  future: {
    y: { one: 'po %s m.', few: 'po %s m.', many: 'po %s m.', other: 'po %s m.' },
    M: { one: 'po %s mėn.', few: 'po %s mėn.', many: 'po %s mėn.', other: 'po %s mėn.' },
    w: { one: 'po %s sav.', few: 'po %s sav.', many: 'po %s sav.', other: 'po %s sav.' },
    d: { one: 'po %s d.', few: 'po %s d.', many: 'po %s d.', other: 'po %s d.' },
    h: { one: 'po %s val.', few: 'po %s val.', many: 'po %s val.', other: 'po %s val.' },
    m: { one: 'po %s min.', few: 'po %s min.', many: 'po %s min.', other: 'po %s min.' },
    s: { one: 'po %s sek.', few: 'po %s sek.', many: 'po %s sek.', other: 'po %s sek.' },
  },
  abbr: {
    y: { one: '%s m.', other: '%s m.' },
    M: { one: '%s mėn.', other: '%s mėn.' },
    w: { one: '%s sav.', other: '%s sav.' },
    d: { one: '%s d.', other: '%s d.' },
    h: { one: '%s val.', other: '%s val.' },
    m: { one: '%s min.', other: '%s min.' },
    s: { one: '%s s', other: '%s s' },
  },
  justNow: 'ką tik',
  yesterday: 'Vakar',
  today: 'Šiandien',
  tomorrow: 'Rytoj',
  weekStart: 1,
};
const localeName: LocaleName = 'lt';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (): string => '',
};
